import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ApiResultModel, getQuotesListService } from "@WhiteCap/Store/Service/OsnQuotes/QuoteListService";

export interface QuoteListApiParameter extends ApiParameter {
    pageNumber: number;
    pageSize: number;
    sortColumn?: string;
    sortDirection?: string;
    searchTerm?: string;
    jobsite?: string;
    quoteNumber?: string;
    createdStartDate?: string;
    createdEndDate?: string;
    expiredStartDate?: string;
    expiredEndDate?: string;
    customerNumber?: string;
    onError?: (message: string) => void;
}
type HandlerType = CustomApiHandler<QuoteListApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/OsnQuoteList/BeginLoadQuoteList",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const {
        pageNumber,
        pageSize,
        sortColumn,
        sortDirection,
        searchTerm,
        jobsite,
        quoteNumber,
        createdStartDate,
        createdEndDate,
        expiredStartDate,
        expiredEndDate,
        customerNumber,
    } = props.apiParameter;
    const result = await getQuotesListService(
        pageNumber,
        pageSize,
        sortColumn,
        sortDirection,
        searchTerm,
        jobsite,
        quoteNumber,
        createdStartDate,
        createdEndDate,
        expiredStartDate,
        expiredEndDate,
        customerNumber,
    );
    if (result.successful && result.result) {
        props.apiResult = result.result;
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/OsnQuoteList/LoadQuoteListError",
        });
        return false;
    }
};

export const DispatchCompleteQuoteListDataLoad: HandlerType = props => {
    props.dispatch({
        type: "Custom/OsnQuoteList/CompleteLoadQuoteList",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteQuoteListDataLoad];

const getQuoteList = createHandlerChainRunner(chain, "GetQuoteList");
export default getQuoteList;
